module.exports = __webpack_public_path__ + "static/img/logo_powered.5df4d5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_powered.png
// module id = i4UL
// module chunks = 94